import {
	DisplayLabel,
	extractLabelValue,
	formatLabelDisplayValue,
	isLabelString,
	transformLabelsForChips as transformLabelsForChipsCommon
} from 'src/common/helpers/LabelDisplayHelpers';
import { ConfigurationLabel } from 'src/common/types/ConfigurationTypes';

import { LABEL_PREFIXES } from '../pages/tests/types/filter-section-v2/FilterConstants';

export const formatUnitIdDisplayValue = (
	value: string,
	unitIdDisplayName: string,
	unitIdLabelConfig?: ConfigurationLabel
): string => {
	return formatLabelDisplayValue(value, unitIdDisplayName, unitIdLabelConfig);
};

export const formatEnvironmentDisplayValue = (
	value: string,
	environmentDisplayName: string,
	environmentLabelConfig?: ConfigurationLabel
): string => {
	return formatLabelDisplayValue(value, environmentDisplayName, environmentLabelConfig);
};

export const extractUnitIdValue = (label: string): string => {
	return extractLabelValue(label, LABEL_PREFIXES.UNIT_ID);
};

export const extractEnvironmentValue = (label: string): string => {
	return extractLabelValue(label, LABEL_PREFIXES.ENVIRONMENT);
};

export const isUnitIdLabelString = (label: string): boolean => {
	return isLabelString(label, LABEL_PREFIXES.UNIT_ID);
};

export const isEnvironmentLabelString = (label: string): boolean => {
	return isLabelString(label, LABEL_PREFIXES.ENVIRONMENT);
};

/**
 * Transforms labels into chips with warning emojis and "Unknown value" tooltips
 * Wrapper around common transformLabelsForChips with websdks-specific config
 */
export const transformLabelsForChips = (
	labels: string[],
	isNewPlatformEnabled: boolean,
	unitIdDisplayName?: string,
	unitIdLabelConfig?: ConfigurationLabel,
	environmentDisplayName?: string,
	environmentLabelConfig?: ConfigurationLabel
): DisplayLabel[] => {
	return transformLabelsForChipsCommon(
		labels,
		isNewPlatformEnabled,
		unitIdDisplayName
			? {
					displayName: unitIdDisplayName,
					labelConfig: unitIdLabelConfig,
					extractValue: extractUnitIdValue,
					isLabelString: isUnitIdLabelString
				}
			: undefined,
		environmentDisplayName
			? {
					displayName: environmentDisplayName,
					labelConfig: environmentLabelConfig,
					extractValue: extractEnvironmentValue,
					isLabelString: isEnvironmentLabelString
				}
			: undefined
	);
};
